<template>
  <div class="col-sm-12 nopads my-2">
          <div class="col-sm-12 item-header">
            <div class="item-text-cont">
              <span class="item-title green">
                {{ result.company_name }}
              </span>
              <span v-if="result.company_business_id">
                  {{ result.company_business_id }}
              </span>
              <table class="table table-sm">
                <tbody>
                  <tr>
                    <th>{{ $t('license_report.superusers') }}</th>
                    <th>{{ $t('license_report.billed_observers') }}</th>
                    <th>{{ $t('license_report.usage_observers') }}</th>
                    <th>{{ $t('license_report.billed_workers') }}</th>
                    <th>{{ $t('license_report.usage_workers') }}</th>
                  </tr>
                  <tr>
                    <td>{{ result.company_super_users }}</td>
                    <td>{{ result.company_observers }}</td>
                    <td>{{ result.supervisor_usage }}</td>
                    <td>{{ result.company_workers }}</td>
                    <td>{{ result.worker_usage }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-12 d-flex justify-content-end">
              <div class="form-check form-switch mx-2">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="invoicingToggle"
                      v-model="showActiveUsers"
                  />
                  <label class="form-check-label" for="invoicingToggle">
                      {{ $t('menu.admin_users') }}
                  </label>
              </div>

              <div class="form-check form-switch mx-2">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="showExpiredUsers"
                  />
                  <label class="form-check-label" for="invoicingToggle">
                      {{ $t('license_report.search_expired_license_rights') }}
                  </label>
              </div>
          </div>
          <div class="row">
              <div v-if="showActiveUsers && users.length > 0" class="col-sm-12 item-detail-container my-2">
                 <h4 class="form-header">{{ $t('license_report.license_holder_users') }} </h4>
                <license-admin-report-table :users="users" @details="showUserDetails"/>
              </div>
              <div v-if="showExpiredUsers && expiredRightsUsers.length > 0" class="col-sm-12 item-detail-container my-2">
                <div>
                  <h4 class="form-header">{{ $t('license_report.expired_license_rights') }} </h4>
                  <license-admin-report-table
                    :users="expiredRightsUsers"
                    @details="showUserDetails"
                  />
                </div>
              </div>
            </div>
  </div>
    <base-modal v-if="selectedUser" :title="selectedUser.username" hide-footer @close="selectedUser = null" size="lg">
        <license-rights-inspector :user-id="selectedUser.id" :last-login-at="selectedUser.lastLoginAt"/>
    </base-modal>
</template>

<script>
import {userHelper} from '../mixins/UserMixin'
import {restApi} from '../mixins/RestApiMixin'
import LicenseAdminReportTable from './LicenseAdminReportTable'
import BaseModal from "@/components/BaseModal";
import LicenseRightsInspector from "@/components/licensereport/LicenseRightsInspector";


export default {
    name: 'LicenseSummaryCompanyItem',
    components: {LicenseRightsInspector, BaseModal, LicenseAdminReportTable},
    mixins: [userHelper, restApi],
    props: {
        result: {
            type: Object,
            required: true
        },
        dateFrom: {
            type: Number,
            required: true
        },
        dateTo: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            selectedUser: null,
            users: [],
            userDataLoaded: false,
            loading: false,
            fetched: false,
            fetchedData: null,
            expiredRightsUsers: [],
            expiredRightsFetched: false,
            showActiveUsers: false,
            showExpiredUsers: false
        }
    },
    watch: {
        showActiveUsers: function (val) {
            if (val && !this.fetched) {
                this.startUserFetch(this.result.company_id)
            }
        },
        showExpiredUsers: function (val) {
            if (val && !this.expiredRightsFetched) {
                this.fetchExpiredRightsUsers(this.result.company_id)
            }
        }
    },
    methods: {
        startUserFetch: function (companyId) {
            if(!this.loading) {
               this.fetchUsers(companyId)
            }
        },
        fetchUsers: function (companyId) {
            let params = {}
            params.company = companyId
            params.dateStart =this.dateFrom
            params.dateEnd = this.dateTo
            this.restFetchParams(this.licenseUsersAdminURL, params, this.handleUsers)

        },
        handleUsers: function (response) {
            this.fetched = true
            this.expiredRightsUsers = []
            this.expiredRightsFetched = false
            this.users = response.data[1]
            this.userDataLoaded = true
            this.loading = false
        },
        fetchExpiredRightsUsers: function (companyId) {
            let params = {}
            params.company = companyId
            this.restFetchParams(this.expiredLicenseUsersAdminURL, params, this.handleExpiredRightsUsers)

        },
        handleExpiredRightsUsers: function (response) {
            this.expiredRightsUsers = response.data[1]
            this.expiredRightsFetched = true
            this.loading = false
        },
        showUserDetails: function (row){
            this.selectedUser = row
        }

    }
}
</script>
<style scoped>
.green {
    color: #7FC000;
}
</style>
